/**
 * Admin user directory hook.
 *
 * Lists all users via the clean GET /users endpoint — used by admin
 * dropdowns and filters (UserSelect, AccessRequests, RoleDetail,
 * LocationDetail). ACL-gated by the admin role on the backend.
 */

import { useAuthenticatedQuery } from '@/hooks/useAuthenticatedQuery';
import { usersApi, type UserSearchResult } from '@/api/endpoints/users';

export function useAdminUsers() {
  return useAuthenticatedQuery<UserSearchResult[]>({
    queryKey: ['users', 'directory'],
    queryFn: () => usersApi.listAll(),
  });
}
